import React from 'react';
import { Box } from '@mui/material';

/**
 * InterviewFlow logo — IF monogram with flow arrow (interviewflow-icon-2.svg).
 * Used in BrandLogo, navbar, dashboard, and everywhere InterviewFlow is shown.
 */
function InterviewFlowLogo({ size = 36 }) {
  return (
    <Box
      component="img"
      src="/interviewflow-icon-2.svg"
      alt="InterviewFlow"
      sx={{
        width: size,
        height: size,
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
    />
  );
}

export default InterviewFlowLogo;
